<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  watch: {
    $route(to) {
      const loginPath = "/shop/login";
      if (
        !this.$store.getters.isSignedIn
        && to.path !== loginPath
        && to.path !== "/shop/signup"
      ) {
        this.$router.push(loginPath);
      }
    }
  },
  created() {
    if (!this.$store.getters.isSignedIn
      && !this.$route.path.startsWith("/shop/login")) {
      this.$router.push("/shop/login");
    }
  }
};
</script>

<style>
</style>
